import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import {
  getContactData,
  getSpeakerContactDataFieldsFiltered,
  getSpeakerContactFirstLastNameFields,
  getSelectedSpeakerContactValues,
  getSelectedSpeakerIsExternal,
  getUserName,
  getSpeakerTabs,
  allowRemovePerson,
  showThisIsYou,
  getSelectedSpeakerAdditionalContacts
} from "../selectors";
import { getters, actions } from "Portal/CallForPapersForm/model";
import InputFields from "./InputFields";
import Field from "./Field";
import ContactEmailField from "./ContactEmailField";
import { Div, MediumOutlineButton } from "components/Base";
import Tabs from "ui-kit/Tabs/View";
import { noop } from "utils/General";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

import {
  FieldsInfoPanel,
  RegisteredSpeakerInfoPanel
} from "./ContactEmailInfoPanels";

const decorate = R.compose(
  connect(
    state => ({
      error: getters.error(state),
      data: getContactData(state),
      isExternalSpeaker: getSelectedSpeakerIsExternal(state),
      contactValues: getSelectedSpeakerContactValues(state),
      additionalContacts: getSelectedSpeakerAdditionalContacts(state),
      contactDataFields: getSpeakerContactDataFieldsFiltered(state),
      firstLastNameFields: getSpeakerContactFirstLastNameFields(state),
      userName: getUserName(state),
      tabs: getSpeakerTabs(state),
      selectedSpeakerId: getters.selectedSpeakerId(state),
      allowRemovePerson: allowRemovePerson(state),
      showThisIsYou: showThisIsYou(state)
    }),
    {
      updateContactValues: actions.updateSpeakerContactValues,
      updateSpeakerAdditionalContact: actions.updateSpeakerAdditionalContact,
      removeSpeakerAdditionalContact: actions.removeSpeakerAdditionalContact,
      addSpeakerAdditionalContact: actions.addSpeakerAdditionalContact,
      removeSpeaker: actions.removeSpeaker
    }
  ),
  CSSModules(css)
);

const ContactPage = ({
  handlers = [],
  error = null,
  data = null,
  updateContactValues = noop,
  updateSpeakerAdditionalContact = noop,
  removeSpeakerAdditionalContact = noop,
  addSpeakerAdditionalContact = noop,
  contactValues = [],
  contactDataFields = [],
  additionalContacts = [],
  firstLastNameFields = "",
  selectedSpeakerId = null,
  removeSpeaker = noop,
  tabs = [],
  allowRemovePerson = false,
  isExternalSpeaker
}) => {
  return (
    <InputFields
      tabIndex={0}
      key={selectedSpeakerId}
      disableShowAlert
      handlers={handlers}
      error={error}
      data={data}
      additionalContacts={additionalContacts}
      values={contactValues}
      updateValues={updateContactValues}
      updateSpeakerAdditionalContact={updateSpeakerAdditionalContact}
      removeSpeakerAdditionalContact={removeSpeakerAdditionalContact}
      addSpeakerAdditionalContact={addSpeakerAdditionalContact}
      fields={contactDataFields}
      isExternalSpeaker={isExternalSpeaker}
    >
      <>
        <Tabs
          tabs={tabs}
          mb={3}
          width={1}
          bb={1}
          bc="neutral1"
          activeValidation={true}
          styleName="speakersTabs"
        />
        {isExternalSpeaker ? (
          <RegisteredSpeakerInfoPanel selectedSpeakerId={selectedSpeakerId} />
        ) : null}
        {allowRemovePerson && (
          <Div display="row.flex-end.center" width={1}>
            <MediumOutlineButton mt={3} mb={4} onClick={removeSpeaker}>
              Remove Person
            </MediumOutlineButton>
          </Div>
        )}
        <Div display="row.flex-start.flex-end">
          <Div flex={1}>
            <Field
              field={firstLastNameFields[0]}
              values={contactValues}
              updateValues={updateContactValues}
            />
          </Div>
          <Div flex={1} ml={2}>
            <Field
              field={firstLastNameFields[1]}
              values={contactValues}
              updateValues={updateContactValues}
            />
          </Div>
        </Div>
        <ContactEmailField />

        {isExternalSpeaker ? <FieldsInfoPanel /> : null}
      </>
    </InputFields>
  );
};

export default decorate(ContactPage);
